/*
 * @Author: zjw
 * @Date: 2021-05-17 17:07:00
 * @LastEditTime: 2023-04-21 17:00:14
 * @FilePath: \web-app\src\network\mainApi.js
 * @Environment: Vue + Element
 * @Description:
 */
import { request } from "./request.js";
// 账号密码登录
export function login(data) {
	return request({
		url: "/aso/app/login",
		method: "post",
		data,
	});
}

// 获取菜单列表
export function getMenuList(data) {
	return request({
		url: "/web/back/sysMenu/menuList",
		method: "get",
		data,
	});
}

// 第三方登录获取网址
export function otherLogin(data) {
	return request({
		url: "/aso/new/uamp/login.action",
		method: "get",
		params: data,
	});
}

// 用code拿账号 /aso/new/uamp/callback.action?code=123&state=STATEiSplfpfxWl&appId=S2RpIV9rW6Xv4a6R
export function useCode(data) {
	return request({
		url: "/aso/new/uamp/callback.action",
		method: "get",
		params: data,
	});
}

// 发送验证码
// export function loginSms(data) {
// 	return request({
// 		url: "/aso/app/loginSms",
// 		method: "get",
// 		params: data,
// 	});
// }

// 用户绑定
export function updateUser(data) {
	return request({
		url: "aso/new/uamp/binding",
		method: "post",
		data,
	});
}

// 获取平台appId
export function getAppid(data) {
	return request({
		url: "/aso/app/getPlatInfo",
		method: "get",
		params: data,
	});
}
// 获取用户角色
export function getUserRoles() {
	return request({
		url: "/web/back/sys/user/getUserRoles",
		method: "get",
	});
}

// 获取手机号验证码
export function getCode(params) {
	return request({
		url: "/aso/app/loginSms",
		method: "get",
		params,
	});
}

// 手机号验证码登录
export function loginSms(params) {
	return request({
		url: "aso/oauth/sms",
		method: "get",
		params,
	});
}

export default {
	login,
	getMenuList,
	otherLogin,
	useCode,
	updateUser,
	getAppid,
	loginSms,
	getCode,
};
